<template>
  <el-dialog
    :title="formTitle"
    :visible.sync="isVisible"
    class="dialog-label-form"
    :class="{'is-edit-mode': isEditMode, 'is-new': state === 'new'}"
    :closeOnClickModal="false"
    append-to-body
    @close="handleDialogClose">
    <div class="label-form-content" v-loading="isLoading">
      <form-label
        :data="data"
        :model="formModel"
        @updateModelItem="handlerUpdateModelItem"
        @change="handleFormData"
        ref="Form"/>
      <form-controls
        isClipboard
        :isBack="isAvailableToSave"
        :isCancel="!isAvailableToSave"
        :isDisabledClipboard="!hasCreateNew"
        :isCreate="!hasCreateNew"
        :isSave="hasCreateNew"
        :isDelete="hasCreateNew"
        class="form-footer"
        @command="setCommand"/>
    </div>
  </el-dialog>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'

export default {
  name: 'ModalNewLabel',
  mixins: [FormWrapper, FormWrapperAutoSave],
  components: {
    'form-label': () => import(/* webpackChunkName: 'Label' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    config: { type: Object }
  },
  data () {
    return {
      // eslint-disable-next-line
      apiPatch: 'Labels/Patch/${data.id}'
    }
  },
  computed: {
    formTitle () {
      return this.hasCreateNew
        ? `${this.L10n('edit')} ${this.formData.labelKey}`
        : this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    formModel () {
      return {
        id: '',
        title: '',
        labelKey: '',
        languageID: ''
      }
    },
    handleDialogClose () {
      let command = this.isAvailableToSave ? 'back' : 'cancel'
      this.setCommand(command)
    }
  }
}
</script>

<style lang="stylus">
  @media only screen and (min-width: 576px) and (max-width: 1220px) {
    .dialog-label-form {
      &:not(.is-new){
        .default-form-controls{
          &>.control{
            width 50%
            &>button{
              width 90%
              margin 0 5%
            }
          }
        }
      }
    }
  }
  @media only screen and (max-width: 992px) {
    .dialog-label-form {
      .default-form-controls{
        &>.control{
          width 100%
          &>button{
            width 80%
            margin 0 10%
          }
        }
      }
    }
  }
</style>
